<template>
  <div class="widget-form-container">
    <el-form
      :size="data.config.size"
      :label-position="data.config.labelPosition"
      :class="{
        [data.config.customClass]: data.config.customClass ? true : false,
        swLabelCenter: data.config.labelPosition === 'center',
      }"
      :label-width="data.config.labelWidth + 'px'"
    >
      <draggable
        class=""
        v-model="data.list"
        v-bind="{
          group: { name: 'people', put: handlePut },
          ghostClass: 'ghost',
          animation: 200,
          handle: '.drag-widget',
        }"
        :no-transition-on-drag="true"
        @end="handleMoveEnd"
        @add="handleWidgetAdd"
      >
        <transition-group name="fade" tag="div" class="widget-form-list">
          <template
            v-for="(element, index) in data.list"
            v-if="element && element.key"
          >
            <advanced-form-item
              v-if="Object.keys(advancedComponents).indexOf(element.type) >= 0"
              :key="element.key"
              :element="element"
              :select.sync="selectWidget"
              :index="index"
              :data="data"
              :data-config="data.config"
              @select-change="handleSelectChange"
            >
            </advanced-form-item>
            <son-form
              v-else-if="element.type === 'sonform'"
              :key="element.key"
              :element="element"
              :select.sync="selectWidget"
              :index="index"
              :data="data"
              :data-config="data.config"
              @select-change="handleSelectChange"
            >
            </son-form>

            <widget-report
              v-else-if="element.type === 'report'"
              :key="element.key + index"
              :element="element"
              :select.sync="selectWidget"
              :index="index"
              :data="data"
              :data-config="data.config"
              @select-change="handleSelectChange"
            ></widget-report>

            <widget-form-item
              v-else-if="element.type !== 'grid'"
              :key="element.key"
              :element="element"
              :select.sync="selectWidget"
              :index="index"
              :data="data"
              :data-config="data.config"
              @select-change="handleSelectChange"
            >
            </widget-form-item>

            <widget-col-item
              v-else
              :key="element.key"
              :element="element"
              :select.sync="selectWidget"
              :index="index"
              :data="data"
              :data-config="data.config"
              @select-change="handleSelectChange"
            >
            </widget-col-item>
          </template>
        </transition-group>
      </draggable>
    </el-form>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import WidgetFormItem from './WidgetFormItem'
import WidgetColItem from './WidgetColItem'
import { advancedComponents } from './advanced/advanced.js'
import AdvancedFormItem from './advanced/AdvancedFormItem'
import SonForm from './advanced/sonfrom/SonForm'
import widgetFormUtils from '../util/widgetFormUtils'
import WidgetReport from './WidgetReport'

export default {
  name: 'widget-son-page-form',
  components: {
    Draggable,
    WidgetFormItem,
    WidgetColItem,
    AdvancedFormItem,
    SonForm,
    WidgetReport,
  },
  props: ['select', 'config', 'page', 'pageTab', 'sonPages'],
  data() {
    return {
      advancedComponents,
      selectWidget: this.select,
      data: { list: this.page, config: this.config, sonPages: this.sonPages },
    }
  },
  mounted() {
    document.body.ondrop = function (event) {
      const isFirefox =
        navigator.userAgent.toLowerCase().indexOf('firefox') > -1
      if (isFirefox) {
        event.preventDefault()
        event.stopPropagation()
      }
    }
  },
  methods: {
    handlePut(a, b, c) {
      if (c.className.indexOf('widget-un-page') >= 0) {
        return false
      }
      return true
    },
    handleMoveEnd() {},
    handleSelectWidget(index) {
      this.selectWidget = this.data.list[index]
    },
    handleWidgetAdd(evt) {
      const newIndex = evt.newIndex
      const to = evt.to
      widgetFormUtils.handleWidgetAdd(newIndex, to, this.data, this, false)
      this.selectWidget = this.data.list[newIndex]
    },
    handleWidgetDelete(index) {
      if (this.data.list.length - 1 === index) {
        if (index === 0) {
          this.selectWidget = {}
        } else {
          this.selectWidget = this.data.list[index - 1]
        }
      } else {
        this.selectWidget = this.data.list[index + 1]
      }

      this.$nextTick(() => {
        this.data.list.splice(index, 1)
      })
    },
    handleSelectChange(index) {
      setTimeout(() => {
        index >= 0
          ? (this.selectWidget = this.data.list[index])
          : (this.selectWidget = {})
      })
    },
  },
  watch: {
    page(val) {
      this.data.list = val
    },
    'data.list': {
      handler(val) {
        this.$emit('update:page', val)
      },
      deep: true,
    },
    select(val) {
      this.selectWidget = val
    },
    selectWidget: {
      handler(val) {
        this.$emit('update:select', val)
      },
      deep: true,
    },
  },
}
</script>
<style>
.swLabelCenter .el-form-item__label {
  text-align: center;
}
</style>
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
